var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTwitter = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 18,
  height: 19,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#001E3C",
  d: "m1.368 1.937 6.174 8.265-6.218 6.716h1.398l5.438-5.882 4.398 5.882h4.766l-6.521-8.72 5.785-6.25H15.19l-5.015 5.416-4.052-5.417H1.357zm2.058 1.029h2.188l9.663 12.912h-2.188z"
})));
export { SvgTwitter as ReactComponent };
export default "data:image/svg+xml;base64,ZXhwb3J0IGRlZmF1bHQgX193ZWJwYWNrX3B1YmxpY19wYXRoX18gKyAiYWE1NWIzMDhkMGY1M2YyY2Q1MzE4MzZkMTU1MjlhYzUuc3ZnIjs=";